<template>
  <div class="genrelist">
    <div class="genrelist-heading">All Genres</div>
    <div class="genrelist-list">
      <div
        v-for="genre in sortedGenres"
        :key="genre.id"
      >
        <span class="genrelist-item"
        :class="{ 'is-selected': selectedGenreId === genre.id }" 
        @click="() => clickItem(genre.id)">
          {{ genre.label }}
        </span>

        <div v-if="selectedGenreId === genre.id">
          <div
          class="subgenrelist-item"
          v-for="subgenre in genre.subgenres"
          :key="subgenre.id"
          :class="{ 'is-selected': selectedSubgenreIds.includes(subgenre.id)}"
          @click="() => clickSubItem(subgenre.id)"
          >
            {{ subgenre.label }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "GenreList",
  props: ["onClickItem","onClickSubItem", "selectedGenreId","selectedSubgenreIds"],
  data: function () {
    return {};
  },
  computed: {
    ...mapState({
      genres: "genres",
    }),
    sortedGenres() {
      let sortedGenres = this.genres.sort(function (a, b) {
        var textA = a.label.toUpperCase();
        var textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      return sortedGenres
    }
  },
  methods: {
    clickItem(genreId) {
      this.onClickItem(genreId);
    },
    clickSubItem(subgenreId) {
      this.onClickSubItem(subgenreId);
    },
  },
};
</script>

<style lang="scss" scoped>
.genrelist {
  .genrelist-heading {
    padding-top: 28px;
    padding-bottom: 4px;
    font-size: 13.5pt;
    font-weight: 600;
    font-family: $font-family;
  }

  .genrelist-item {
    font-size: 11pt;
    font-family: $font-family;
    cursor: pointer;
  }

  .genrelist-item:hover {
    color: #666;
  }

  .genrelist-item.is-selected {
    font-weight: 600;
    text-decoration: underline;
    color: #111 !important;
  }

  .subgenrelist-item {
    margin-left: 1em;
    font-size: 11pt;
    font-family: $font-family;
    cursor: pointer;
  }

  .subgenrelist-item:hover {
    color: #666;
  }

  .subgenrelist-item.is-selected {
    font-weight: 600;
    text-decoration: underline;
    color: #111 !important;
  }
}

// .subgenrelist {
//   .subgenrelist-item {
//     margin-right: 10px;
//     font-size: 11pt;
//     font-family: $font-family;
//     cursor: pointer;
//   }

//   .subgenrelist-item:hover {
//     color: #666;
//   }

//   .subgenrelist-item.is-selected {
//     font-weight: 600;
//     text-decoration: underline;
//     color: #111 !important;
//   }
// }
</style>
